import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import SEOLandingPage from '../components/seoLandingPage/SEOLandingPage';
import CategoryOverviewPage from '../components/seoLandingPage/CategoryOverviewPage';
import seoPages from '../data/seoPages.json';

/**
 * Generates all SEO landing page routes dynamically from seoPages.json
 * @returns {Array} Array of Route components
 */
export const generateSEORoutes = () => {
  const routes = [];
  
  // Iterate through all categories
  Object.entries(seoPages.categories).forEach(([categoryKey, category]) => {
    // Add category overview page route (e.g., /stellendatenbank)
    routes.push(
      <Route
        key={category.slug}
        path={`/${category.slug}`}
        element={
          <CategoryOverviewPage 
            category={category}
          />
        }
      />
    );
    
    // Iterate through all pages in each category
    category.pages.forEach((page) => {
      // Weiterleitung für index Vergleichsseite zur Startseite
      if (page.slug === 'index-anzeigendaten-alternative') {
        routes.push(
          <Route
            key={page.slug}
            path={`/${page.slug}`}
            element={<Navigate to="/" replace />}
          />
        );
        return;
      }

      routes.push(
        <Route
          key={page.slug}
          path={`/${page.slug}`}
          element={
            <SEOLandingPage 
              pageData={page} 
              category={category}
            />
          }
        />
      );
    });
  });
  
  return routes;
};

/**
 * Gets all page slugs for sitemap generation
 * @returns {Array} Array of page slugs
 */
export const getAllSEOSlugs = () => {
  const slugs = [];
  
  // Add category slugs
  Object.values(seoPages.categories).forEach((category) => {
    slugs.push(category.slug);
    
    // Add page slugs
    category.pages.forEach((page) => {
      slugs.push(page.slug);
    });
  });
  
  return slugs;
};

/**
 * Gets page data by slug
 * @param {string} slug 
 * @returns {Object|null} Page data or null
 */
export const getPageDataBySlug = (slug) => {
  for (const category of Object.values(seoPages.categories)) {
    const page = category.pages.find(p => p.slug === slug);
    if (page) {
      return { page, category };
    }
  }
  return null;
};

// Pre-generated routes for direct import
export const seoRoutes = generateSEORoutes();
